<template>
  <b-row>
    <b-col md="6">
      <v-select
        v-model="selectedPhoneId"
        placeholder="Search by phone number"
        label="phoneNumber"
        :options="phoneNumbers"
        :reduce="opt => opt.id"
        @search="fetchPhones"
      />
    </b-col>
    <b-col md="3">
      <b-button
        :disabled="!selectedPhoneId || isLoading"
        variant="primary"
        @click="replacePhone"
      >
        <b-spinner
          v-if="isLoading"
          small
        />
        <span v-else>Replace</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, computed } from '@vue/composition-api'
import { debounce } from 'lodash'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driverStore from '../driverStoreModule'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    vSelect,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  setup(_, ctx) {
    useRegisterStoreModule('drivers', driverStore)
    const currentDriver = computed(() => ctx.root.$store.getters['drivers/currentDriver'])
    const selectedPhoneId = ref(null)
    const phoneNumbers = ref([])
    const fetchPhones = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      const res = await ctx.root.$store.dispatch('drivers/fetchDrivers', { phoneNumber: search })
      phoneNumbers.value = res.drivers
      loading(false)
    }, 1000)

    const isLoading = ref(false)
    const replacePhone = async () => {
      isLoading.value = true
      const loggedUser = JSON.parse(localStorage.getItem('userData'))
      try {
        await ctx.root.$store.dispatch('drivers/replacePhoneNumber', {
          newDriverId: selectedPhoneId.value,
          driverId: currentDriver.value.id,
          actorId: loggedUser.email,
        })
        window.location.reload()
      } catch (err) {
        errorNotification(err.response.data.error.errors[0].message)
      } finally {
        isLoading.value = false
      }
    }
    return {
      fetchPhones,
      phoneNumbers,
      selectedPhoneId,
      replacePhone,
      isLoading,
    }
  },
}
</script>

<style>

</style>
